import api from './APIService';

class RegisteredMembersService {
	findOrganizations(data) {
		return api.fetch({ method: 'post', path:'/livelaps/organization/find', data });
	}
	getList(id) {
		return api.fetch({ method: 'get', path: '/livelaps/organization/registrants/' + id });
	}
}

export default new RegisteredMembersService();